import axios from '@/utils/axios';

export const changePwd = async (oldPassword, password) => {
    const params = { oldPassword, password };
    return await axios.put('/api/permission/user/changePwd', params);
};
